
import { HeroRegla } from "../../components/reglamento/HeroReglas";
import { ReglasGrid } from "../../components/reglamento/Reglas";
export const ReglamentoPages = () => {
    return(
        <>
        <HeroRegla/>
        <ReglasGrid/>
        </>
    )
}